import {
  type CategorizedResponse,
  LocationQueryEnum,
  type Suggestion,
} from "@b2bportal/air-shopping-api";
import { flightsShoppingApi } from "@overrides/utilities";
import type { FlightSuggestion } from "./types";

export const fetchLocations = async (
  search: string,
  callback: (newOptions: FlightSuggestion[]) => void
): Promise<void> => {
  try {
    const res = await flightsShoppingApi.apiV0AutocompleteLocationPost({
      LocationQuery: LocationQueryEnum.Label,
      l: search,
    });

    const options = res.data.categories?.reduce<FlightSuggestion[]>(
      (acc: Suggestion[], categoryRes: CategorizedResponse) => {
        acc.push(
          ...categoryRes.results.map((s) => {
            return {
              ...s,
              category: categoryRes.category,
              categoryLabel: categoryRes.label,
            };
          })
        );
        return acc;
      },
      []
    );
    callback(options);
  } catch (e) {
    callback([]);
  }
};
